// Tabs shared by the V2 admin pages (BRIEFS C4.4) + small helpers.
import React from 'react';
import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/admin/v2/chapters', label: 'Notes (by chapter)' },
  { to: '/admin/v2/dictionary', label: 'Dictionary' },
  { to: '/admin/v2/clips', label: 'Video clips' },
  { to: '/admin/v2/videos/import', label: 'Videos: import' },
  { to: '/admin/v2/videos/approve', label: 'Videos: approve' },
  { to: '/admin/v2/links', label: 'Question links' },
  { to: '/admin/v2/one-liners', label: 'One-liners' },
  { to: '/admin/v2/pyq', label: 'PYQ tags' },
];

// C11.7: the older notes pages stay reachable here, but no longer in the main menu.
const ADVANCED = [
  { to: '/admin/v2/notes', label: 'Notes loader (whole file)' },
  { to: '/admin/v2/points', label: 'Point editor' },
  { to: '/admin/v2/module-map', label: 'Module map' },
];

// The student side of Version 2 (C3.4): what he did, the daily reports, his devices, settings.
const STUDENT_TABS = [
  { to: '/admin/v2/activity', label: 'Activity' },
  { to: '/admin/v2/reports', label: 'Daily reports' },
  { to: '/admin/v2/devices', label: 'Devices' },
  { to: '/admin/v2/settings', label: 'Study settings' },
];

export default function V2Tabs({ title, intro, group = 'notes' }) {
  const tabs = group === 'student' ? STUDENT_TABS : TABS;
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Version 2 · {group === 'student' ? 'Student' : 'Notes'}</div>
      <h1 style={{ fontSize: 26, marginTop: 2 }}>{title}</h1>
      {intro && <p style={{ color: 'var(--text-muted)', marginTop: 4, maxWidth: 820 }}>{intro}</p>}
      <nav style={{ display: 'flex', gap: 6, marginTop: 14, flexWrap: 'wrap' }}>
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} style={({ isActive }) => ({
            padding: '8px 14px', borderRadius: 8, fontSize: 14, textDecoration: 'none',
            border: '1px solid var(--border)',
            background: isActive ? 'var(--primary)' : 'var(--surface)',
            color: isActive ? 'white' : 'var(--text)', fontWeight: isActive ? 600 : 400,
          })}>{t.label}</NavLink>
        ))}
      </nav>
      {group !== 'student' && (
        <div data-testid="v2-advanced" style={{ display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap', alignItems: 'center', fontSize: 13 }}>
          <span style={{ color: 'var(--text-muted)' }}>Advanced:</span>
          {ADVANCED.map((t) => (
            <NavLink key={t.to} to={t.to} style={({ isActive }) => ({
              color: isActive ? 'var(--primary)' : 'var(--text-muted)', fontWeight: isActive ? 600 : 400,
            })}>{t.label}</NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export function Msg({ msg }) {
  if (!msg) return null;
  const ok = msg.kind === 'ok';
  return (
    <div className="card" role="status" style={{
      marginBottom: 16, padding: '14px 18px',
      borderColor: ok ? 'var(--success)' : 'var(--danger)',
      color: ok ? '#047857' : '#B91C1C',
    }}>{msg.text}</div>
  );
}

export const chapterLabel = (c) => `Class ${c.class_level} · Chapter ${c.ncert_no} — ${c.title}`;

// The same colour classes as the student's Notes page, for previews.
export const NOTES_CSS = `
  .v2n { font-family: 'Atkinson Hyperlegible', 'DM Sans', sans-serif; font-size: 17px; line-height: 1.55; color: #0F172A; }
  .v2n .c-red { color: #B42318; font-weight: 600; }
  .v2n .c-blue { color: #1D4ED8; font-weight: 600; }
  .v2n .c-green { color: #15803D; }
  .v2n .c-mark { background: #FFF1A8; padding: 0 2px; border-radius: 2px; }
  .v2n table { border-collapse: collapse; margin: 6px 0; font-size: 15px; }
  .v2n th, .v2n td { border: 1px solid #CBD5E1; padding: 4px 8px; text-align: left; }
  .v2n th { background: #F1F5F9; }
`;
